import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import GeometryGrid from '../Helper/GeometryGrid';
import Grid from '../Helper/Grid';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
// import Alerte from './Alerte';
import Document from './Document';
import Tarification from './Tarification';
import TarificationRecap from './Tarification/TarificationRecap';

class ElementContrat extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "ElementContrat";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack =
      <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de l'élément d'occupation.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idElementContrat" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idElementContrat")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}>N°</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("libelle")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Parcelle</Col>
            <Col sm={2}><FormControl id="parcelle" onChange={this.handleChange} type="text" value={this.getObjectProperty("parcelle")} disabled={this.getReadOnly()} /></Col>
            <Col componentClass={ControlLabel} sm={1}>lot</Col>
            <Col sm={1}><FormControl id="numeroLot" onChange={this.handleChange} type="text" value={this.getObjectProperty("numeroLot")} disabled={this.getReadOnly()} /></Col>
            <Col componentClass={ControlLabel} sm={1}>bâtiment</Col>
            <Col sm={1}><FormControl id="numeroBati" onChange={this.handleChange} type="text" value={this.getObjectProperty("numeroBati")} disabled={this.getReadOnly()} /></Col>
            <Col componentClass={ControlLabel} sm={1}>cellule</Col>
            <Col sm={1}><FormControl id="numeroCellule" onChange={this.handleChange} type="text" value={this.getObjectProperty("numeroCellule")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {this.state.mode !== "add" &&
            <FormGroup bsClass="btnLinks">
              <PermissionCheck component={Tarification.getClassName()} permission={PERMISSION_READ}>
                <TarificationRecap object={this.getObjectProperty("tarification")} withEdit={true} withAllParams={true} mode={this.state.mode} />
              </PermissionCheck>
            </FormGroup>
          }

          {/* Geom OneToMany */}
          {(this.state.mode !== "add") ?
            <GeometryGrid title="Géométries" path="elementcontrats_geoms" objectPath={"elementcontrats_geoms/" + this.getObjectProperty("idElementContrat")} objectClass={ElementContrat}
              mode={this.state.mode} queryLayers={"ElementContratCreate"}
              allowDraw={false} selectionMultiple={true} typeGeometry="polygon" withImportCsv={false} withImportPoint={false} /> : null
          }

          {/* Alerte OneToMany */}
          {/* {this.state.mode !== "add" &&
            <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Alertes" path="alertes" objectPath={"elementcontrats/" + this.getObjectProperty("idElementContrat") + "/alertes"} objectClass={Alerte}
                hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          } */}

          {/* Document OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Document.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Documents" path="documents" objectPath={"elementcontrats/" + this.getObjectProperty("idElementContrat") + "/documents"} objectClass={Document}
                hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>

      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idElementContrat";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    const elementContratObj = cloneObject(this.state.object);

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(elementContratObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Elément de l\'occupation sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Elément de l\'occupation créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/elementcontrats/" + newObj[this.getIdField()] + "/edit", state);
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * handleActiviteChange
  * Modify the state idActivite property from idActivite Combobox change
  **/
  handleActiviteChange(activite) {
    let objState = this.state;
    objState.object["idActivite"] = (activite === undefined) ? null : activite.idActivite;
    this.setState(objState);
  }

  /**
  * handleAOTChange
  * Modify the state idAot property from idAot Combobox change
  **/
  handleAOTChange(aot) {
    let objState = this.state;
    objState.object["idAot"] = (aot === undefined) ? null : aot.idAot;
    this.setState(objState);
  }

}

export default ElementContrat;



// WEBPACK FOOTER //
// ./src/views/Entity/ElementContrat.js